import React from "react";
import { awsS3BaseURL, internalFilesBaseURL } from "@/lib/Constants";

export interface CopyTextProps {
    text: string;
}

const DescriptionCompiler = ({ text }: CopyTextProps) => {
    text = text.replaceAll(awsS3BaseURL, internalFilesBaseURL);

    if (!text) {
        return <></>;
    }

    return <div dangerouslySetInnerHTML={{ __html: text }}></div>;
};

export default DescriptionCompiler;
